import axios from "axios";
const WebinarListAPI = async (token, bimbelType) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const params = `/admin/webinar/list?token=${token}&bimbelType=${bimbelType}`;
    const url = `${BASED_URL}${params}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    return err.response;
  }
};

export default WebinarListAPI;
